import styled from "styled-components"
import { WrapPopupEdit } from "../index.style"

const WrapPopupEditCCCD = styled(WrapPopupEdit)`
    
`

export {
    WrapPopupEditCCCD
}